import { singleOrArrayToArray } from '@dirootie-extensions/javascript';
import { SingleOrArray } from '@dirootie-extensions/typescript';
import _ from 'lodash';

export function objectToPaths(obj: any, parentKey?: string): string[] {
  var result: string[];
  if (_.isArray(obj)) {
    var idx = 0;
    result = _.flatMap(obj, function (obj: any) {
      return objectToPaths(obj, (parentKey || '') + '[' + idx++ + ']');
    });
  } else if (_.isPlainObject(obj)) {
    result = _.flatMap(_.keys(obj), function (key) {
      return _.map(objectToPaths(obj[key], key), function (subkey) {
        return (parentKey ? parentKey + '.' : '') + subkey;
      });
    });
  } else {
    result = [];
  }
  return _.concat(result, parentKey || []);
}

export type PathResult = {
  segments: string[];
  value: any;
  path: string;
};

function internalToPathWithResult(
  obj: any,
  acc: {
    segments: string[];
    value: any;
    parentKey: string;
    path: string;
  },
  stopKey: string
): {
  segments: string[];
  value: any;
  parentKey: string;
  path: string;
}[] {
  var result: {
    segments: string[];
    value: any;
    parentKey: string;
    path: string;
  }[] = [
    {
      segments: [],
      value: obj,
      parentKey: '',
      path: '',
    },
  ];
  if (_.isArray(obj)) {
    var idx = 0;
    result = _.flatMap(obj, function (obj: any) {
      acc.parentKey = (acc.parentKey || '') + '[' + idx++ + ']';
      acc.value = obj;
      return internalToPathWithResult(obj, acc, stopKey);
    });
  } else if (_.isPlainObject(obj)) {
    result = _.flatMap(_.keys(obj), function (key) {
      if (acc.parentKey === stopKey) {
        acc.parentKey = (acc.parentKey ? acc.parentKey + '.' : '') + key;
        acc.segments = [...acc.segments, acc.parentKey, key];
        return acc;
      }
      return _.map(
        internalToPathWithResult(obj[key], acc, stopKey),
        function (subkey) {
          acc.value = obj[key];
          acc.parentKey =
            (acc.parentKey ? acc.parentKey + '.' : '') + subkey.parentKey;
          acc.segments = [...acc.segments, acc.parentKey, subkey.parentKey];
          return acc;
          //return (parentKey ? parentKey + '.' : '') + subkey;
        }
      );
    });
  } else {
    result = [acc];
  }
  return _.concat(result, acc ? [acc] : []);
}

function internalToPath(
  obj: any,
  parentKey: string,
  stopKey: SingleOrArray<string> = [],
  stopParentKey: SingleOrArray<string> = [],
  onlyKey: SingleOrArray<string> = []
): string[] {
  var result: string[] = [];
  if (!stopKey.includes(parentKey)) {
    if (_.isArray(obj)) {
      var idx = 0;
      result = _.flatMap(obj, function (obj: any) {
        return internalToPath(
          obj,
          (parentKey || '') + '[' + idx++ + ']',
          stopKey,
          stopParentKey,
          onlyKey
        );
      });
    } else if (_.isPlainObject(obj)) {
      result = _.flatMap(_.keys(obj), function (key) {
        if (stopKey!.includes(key) || stopParentKey.includes(parentKey)) {
          return (parentKey ? parentKey + '.' : '') + key;
        }
        return _.map(
          internalToPath(obj[key], key, stopKey, stopParentKey, onlyKey),
          function (subkey) {
            return (parentKey ? parentKey + '.' : '') + subkey;
          }
        );
      });
    } else {
      result = [];
    }
  }
  return _.concat(result, parentKey || []);
}

export function toPath(
  obj: any,
  options: { parentKey?: string; stopKey?: string } = {
    parentKey: '',
    stopKey: undefined,
  }
): string[] {
  return internalToPath(obj, options!.parentKey!, options.stopKey);
}

export function toPathWithResult(
  obj: any,
  options: {
    parentKey?: string;
    stopKey?: SingleOrArray<string>;
    stopParentKey?: SingleOrArray<string>;
    onlyKey?: SingleOrArray<string>;
  } = {
    parentKey: '',
    stopKey: undefined,
    onlyKey: undefined,
  }
): any[] {
  const stopKey = singleOrArrayToArray(options.stopKey);
  const onlyKey = singleOrArrayToArray(options.onlyKey);
  const stopParentKey = singleOrArrayToArray(options.stopParentKey);
  return internalToPath(
    obj,
    options.parentKey!,
    stopKey!,
    stopParentKey,
    onlyKey
  ).map((x) => ({
    segments: x.split('.'),
    path: x,
    value: _.get(obj, x),
  }));
}

export function toPathWithResult_All(
  obj: any,
  options: {
    parentKey?: string;
    stopKey?: SingleOrArray<string>;
    stopParentKey?: SingleOrArray<string>;
    onlyKey?: SingleOrArray<string>;
  } = {
    parentKey: '',
    stopKey: undefined,
    onlyKey: undefined,
  }
): any[] {
  const res = singleOrArrayToArray(options.stopKey);
  const onlyKey = singleOrArrayToArray(options.onlyKey);
  const stopParentKey = singleOrArrayToArray(options.stopParentKey);
  return internalToPath(
    obj,
    options.parentKey!,
    res!,
    stopParentKey,
    onlyKey
  ).map((x) => ({
    segments: x.split('.'),
    path: x,
    value: _.get(obj, x),
  }));
}
